import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useLocale } from '../context/LocaleContext';

export default function Login() {
  const { login } = useAuth();
  const { t } = useLocale();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
    } catch (e) {
      setError(e.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div
        className="auth-bg"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/cart.jpg'})` }}
      />
      <div className="auth-card">
        <div className="auth-header">
          <img src={process.env.PUBLIC_URL + '/assets/logo.png'} alt="Logo" className="brand-logo" />
          <h1>{t('brand_title')}</h1>
          <p className="muted">{t('sign_in_to_continue')}</p>
        </div>
        <form onSubmit={handleSubmit} className="auth-form">
          <label>
            <span>{t('username')}</span>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder={t('username')}
              autoComplete="username"
              required
            />
          </label>
          <label>
            <span>{t('password')}</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t('password')}
              autoComplete="current-password"
              required
            />
          </label>
          {error && <div className="form-error">{error}</div>}
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Signing in…' : t('sign_in')}
          </button>
        </form>
      </div>
    </div>
  );
}
